import React, { Component } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import LoginLayout from "layouts/login/LoginLayout";
import DashboardLayout from "layouts/dashboard/DashboardLayout";
import LoginPage from "views/auth/LoginPage";
import ForgotPasswordPage from "views/auth/ForgotPasswordPage";
import ResetPasswordPage from "views/auth/ResetPasswordPage";
import LogoutRoute from "views/auth/LogoutRoute";
import DashboardPage from "views/dashboard/DashboardPage";
import CurrentSubscriptionsPage from "views/myAccount/CurrentSubscriptionsPage";
import PastSubscriptionsPage from "views/myAccount/PastSubscriptionsPage";
import OrderHistoryPage from "views/myAccount/OrderHistoryPage";
import OrderReceiptPage from "views/myAccount/OrderReceiptPage";
import SettingsPage from "views/myAccount/SettingsPage";
import EventsPage from "views/tools/EventsPage";
import NewsPage from "views/news/NewsPage";
import ShopPage from "views/shop/ShopPage";
import ProductDetailPage from "views/shop/ProductDetailPage";
import EventDetailPage from "views/tools/EventDetailPage";
import CheckoutPage from "views/shop/CheckoutPage";
import TaxFormPage from "views/verification/taxForm/TaxFormPage";
import AccountVerificationPage from "views/verification/accountVerification/AccountVerificationPage";
import CommingSoon from "views/commingSoon/CommingSoonPage";
import DonationHistoryPage from "views/myAccount/DonationHistoryPage";
import DonationReceiptPage from "views/myAccount/DonationReceiptPage";
import CausesPage from "views/causes/CausesPage";
import CausesDetails from "views/causes/causeDetails/index";
import PartnersPage from "views/partners/PartnersPage";
import SuggestPage from "views/suggest/SuggestPage";
import DonatePage from "views/donate/DonatePage";

const Routes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <UnauthedRoute path="/login" component={LoginPage} />
        <UnauthedRoute path="/forgot-password" component={ForgotPasswordPage} />
        <UnauthedRoute
          path="/auth/check_secret_key"
          component={ResetPasswordPage}
        />
        <Route path="/logout" component={LogoutRoute} />
        <AuthedRoute
          path="/dashboard"
          component={DashboardPage}
          perms={["affiliate"]}
        />
        <AuthedRoute
          path="/subscription/current-subscriptions"
          component={CurrentSubscriptionsPage}
          perms={["affiliate", "preferred"]}
        />
        <AuthedRoute
          path="/subscription/past-subscriptions"
          component={PastSubscriptionsPage}
          perms={["affiliate", "preferred"]}
        />
        <AuthedRoute
          path="/order-history"
          component={OrderHistoryPage}
          perms={["affiliate", "preferred"]}
        />
        <Route
          path="/order-receipt/:orderId"
          component={OrderReceiptPage}
          perms={["affiliate", "preferred"]}
        />
        <AuthedRoute
          path="/settings"
          component={SettingsPage}
          perms={["affiliate", "preferred"]}
        />
        <AuthedRoute
          path="/donation-receipts"
          component={DonationHistoryPage}
          perms={["affiliate", "preferred"]}
        />
        <Route
          path="/donation-receipt/:orderId"
          component={DonationReceiptPage}
          perms={["affiliate", "preferred"]}
        />
        <AuthedRoute
          path="/causes"
          component={CausesPage}
          perms={["affiliate", "preferred"]}
        />
        <AuthedRoute
          path="/causes-details/:id"
          component={CausesDetails}
          perms={["affiliate", "preferred"]}
        />
        <AuthedRoute
          path="/news"
          component={NewsPage}
          perms={["affiliate", "preferred"]}
        />
        <AuthedRoute
          path="/partners"
          component={PartnersPage}
          perms={["affiliate", "preferred"]}
        />
        <AuthedRoute
          path="/events"
          component={EventsPage}
          perms={["affiliate", "preferred"]}
        />
        <AuthedRoute
          path="/event/detail/:eventId"
          component={EventDetailPage}
          perms={["affiliate", "preferred"]}
        />
        <AuthedRoute
          path="/suggest"
          component={SuggestPage}
          perms={["affiliate", "preferred"]}
        />
        <AuthedRoute
          path="/shop/home"
          component={ShopPage}
          perms={["affiliate", "preferred"]}
        />
        <AuthedRoute
          path="/donate/:id"
          component={DonatePage}
          perms={["affiliate", "preferred"]}
        />
        <AuthedRoute
          path="/shop/product/:productId"
          component={ProductDetailPage}
          perms={["affiliate", "preferred"]}
        />
        <AuthedRoute
          path="/shop/checkout"
          component={CheckoutPage}
          perms={["affiliate", "preferred"]}
        />
        <AuthedRoute
          path="/tax-form"
          component={TaxFormPage}
          perms={["need_tax"]}
        />
        <AuthedRoute
          path="/verification"
          component={AccountVerificationPage}
          perms={["need_verification"]}
        />
        <Redirect to="/dashboard" />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;

const UnauthedRoute = ({ component: Component, ...props }) => (
  <Route
    {...props}
    render={(props) => (
      <LoginLayout>
        <Component {...props} />
      </LoginLayout>
    )}
  />
);

const AuthedRoute = ({ component: Component, fullLayout, perms, ...props }) => {
  return (
    <Route
      {...props}
      render={(props) => (
        <DashboardLayout fullLayout={fullLayout} perms={perms}>
          <Component {...props} />
        </DashboardLayout>
      )}
    />
  );
};
